import type { AssetCatalogEntry } from '@buxus/shared'

/** Hide product line when it duplicates the asset display name. */
export function catalogProductLabel(entry: AssetCatalogEntry): string | null {
  const product = entry.productLabel?.trim()
  if (!product) return null
  if (product.localeCompare(entry.displayName.trim(), undefined, { sensitivity: 'base' }) === 0) {
    return null
  }
  return product
}
